import React from 'react';
import { useTheme, type ThemeId } from '../theme/theme';
import { ArrowLeftIcon, BellIcon, HomeIcon, SearchIcon, type IconProps } from './icons';
import { useIconStyle } from './iconStyle';

export type TopIconName = 'back' | 'home' | 'notifications' | 'search';

export function topIconPath(theme: ThemeId, name: TopIconName): string {
  return `/generated-icons/top-${name}-${theme}.png`;
}

export interface TopIconProps {
  name: TopIconName;
  size: number;
  className?: string;
}

const STANDARD_TOP_ICONS: Record<TopIconName, React.ComponentType<IconProps>> = {
  back: ArrowLeftIcon,
  home: HomeIcon,
  notifications: BellIcon,
  search: SearchIcon,
};

export const TopIcon: React.FC<TopIconProps> = ({ name, size, className }) => {
  const { theme } = useTheme();
  const { iconStyle } = useIconStyle();

  if (iconStyle === 'standard-svg') {
    const Icon = STANDARD_TOP_ICONS[name];
    return <Icon className={className} size={size} aria-hidden="true" />;
  }

  // 顶栏 home 是快捷入口，不是当前路由指示器；仅星空主题的手绘位图
  // 使用了类似选中态的实心图，因此切回同色系中性线框图。
  if (name === 'home' && theme === 'starlight') {
    return <HomeIcon className={className} size={size} aria-hidden="true" />;
  }

  return (
    <img
      className={className}
      src={topIconPath(theme, name)}
      alt=""
      aria-hidden="true"
      width={size}
      height={size}
    />
  );
};

export default TopIcon;
